import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=58db0f4b&scoped=true&"
import script from "./detailModal.vue?vue&type=script&lang=js&"
export * from "./detailModal.vue?vue&type=script&lang=js&"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=58db0f4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db0f4b",
  null
  
)

export default component.exports